<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query.scheduleType" :options="scheduleTypes" clearable placeholder="business.label.type" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button :disabled="selectedRows.length===0" content="button.retrying" icon="vxe-icon-repeat" status="primary" @click="retry(selectedRows)"/>
        <vxe-button :disabled="selectedRows.length===0" content="button.cancel" icon="vxe-icon-undo" status="danger" @click="cancel(selectedRows)"/>
      </template>
      <vxe-table
        ref="table"
        :checkbox-config="{trigger: 'cell', highlight: true}"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe
        @checkbox-change="onCheckboxChange"
        @checkbox-all="onCheckboxChange">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:scheduleTypes}" field="scheduleType" title="business.label.type" width="150"/>
        <vxe-column field="addTime" title="business.label.generatedTime" width="170"/>
        <vxe-column field="editTime" title="business.label.editTime" width="170"/>
        <vxe-column field="data" title="business.label.data"/>
        <vxe-column field="errorMessage" title="business.label.errorMessage"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.retrying" icon="vxe-icon-repeat" status="primary" @click.stop="retry([row.id])"/>
            <vxe-button content="button.cancel" icon="vxe-icon-undo" status="danger" @click.stop="cancel([row.id])"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/api'
import { findAll, findEnum, post } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ScheduleErrorHandle',
  data() {
    return {
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      data: [],
      scheduleTypes: [],
      selectedRows: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8),
      query: {
        scheduleType: undefined
      }
    }
  },
  created() {
    Promise.all([
      findEnum('ScheduleType').then(res => {
        if (res.success) {
          this.scheduleTypes = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
    ]).then(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    onCheckboxChange({ checked, row, records }) {
      this.selectedRows = records.map(item => item.id)
    },
    fetch() {
      this.loading = true
      findAll('scheduleErrorFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    retry(ids) {
      this.loading = true
      post(api.scheduleRepublishAll, null, { ids: ids }).then(res => {
        if (res.success) {
          this.$message.success('重试成功')
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    cancel(ids) {
      this.loading = true
      post(api.scheduleCompleteAll, null, { ids: ids }).then(res => {
        if (res.success) {
          this.$message.success('取消成功')
          this.refresh()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>